import { useMutation } from "@shared/lib/hooks";

import { ToastService } from "@shared/lib/services";
import { REPORTS_LIST_QUERY_KEY } from "../constants";
import { ReportService } from "../services/Report.servie";

export function useCreateReport() {
  const {
    mutate: crateReport,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: async ({
      name,
      updateForIntervalHourFrequency,
      updateTillDate,
    }: {
      name: string;
      updateForIntervalHourFrequency: number;
      updateTillDate: string;
    }) => {
      return await ReportService.createReport({
        name,
        updateForIntervalHourFrequency,
        updateTillDate,
      }).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: [REPORTS_LIST_QUERY_KEY],
      skipInvalidation: false,
    },
    onSuccess: (c, _) => {
      // c.invalidateQueries({ queryKey: REPORTS_LIST_QUERY_KEY });
    },
  });
  return {
    crateReport,
    isLoading: isCreating,
    isCreated,
  };
}
